var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopMenuSignIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_5560",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 5560",
    width: 16,
    height: 16,
    transform: "translate(0)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_20832",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 20832",
    transform: "translate(-0.352 -0.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_20832-2",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 20832",
    transform: "translate(0.353 0.004)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_291903",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 291903",
    d: "M9.621,15.845H1.245A1.247,1.247,0,0,1,0,14.6V1.249A1.247,1.247,0,0,1,1.245,0H9.621a1.247,1.247,0,0,1,1.245,1.245v2.4a.317.317,0,0,1-.634,0v-2.4A.612.612,0,0,0,9.621.638H1.245a.612.612,0,0,0-.612.612V14.6a.612.612,0,0,0,.612.612H9.621a.612.612,0,0,0,.612-.612V12.011a.317.317,0,1,1,.634,0V14.6a1.247,1.247,0,0,1-1.245,1.245Z",
    transform: "translate(-0.035 -0.004)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_291904",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 291904",
    d: "M394.765,576.313a.317.317,0,0,1-.317.317H384.31a.317.317,0,1,1,0-.634h10.138a.317.317,0,0,1,.317.317",
    transform: "translate(-378.959 -568.393)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_291905",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 291905",
    d: "M338.965,577.108l2.666,2.666a.317.317,0,0,1-.448.448l-2.666-2.666a.317.317,0,0,1,.448-.448Z",
    transform: "translate(-333.992 -569.398)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_291906",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 291906",
    d: "M341.6,373.122a.317.317,0,0,1,0,.448l-2.666,2.666a.317.317,0,1,1-.448-.448l2.666-2.666a.317.317,0,0,1,.448,0Z",
    transform: "translate(-333.962 -368.105)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopMenuSignIn);
export default __webpack_public_path__ + "static/media/top-menu-sign-in.add54a4c862e8875c09bac05ff1dca4d.svg";
export { ForwardRef as ReactComponent };